const overlay = 'linear-gradient(rgba(240, 240, 240, 0.85),  rgba(240, 240, 240, 0.85))'

export default ({ fundraisingPage }, { colors, measures, rhythm, scale }) => ({
  root: {
    position: 'relative',
    textAlign: 'center'
  },

  dropzone: {
    position: 'relative',
    width: '100%',
    paddingBottom: '80%',
    backgroundColor: colors.shade,
    backgroundImage: fundraisingPage.image && `${overlay}, url(${fundraisingPage.image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },

  content: {
    position: 'absolute',
    top: '50%',
    left: rhythm(2),
    right: rhythm(2),
    transform: 'translateY(-50%)',
    lineHeight: measures.medium,
    textAlign: 'center',

    '& p': {
      marginTop: rhythm(0.5),
      fontSize: scale(1.5)
    }
  },

  editor: {
    width: '100% !important',
    height: 'auto !important',
    backgroundColor: colors.lightGrey
  },

  clear: {
    marginTop: rhythm(0.5),
    fontSize: scale(-1),
    textDecoration: 'underline',
    opacity: 0.5
  },

  note: {
    maxWidth: rhythm(10),
    margin: `${rhythm(1)} auto`,
    fontSize: scale(-1),
    lineHeight: measures.medium,
    opacity: 0.5
  }
})
